'use client';

import { useSearchParams } from 'next/navigation';

export function SearchParamReplacer({
  paramName,
  fallback,
  defaultValue,
}: {
  paramName: string;
  fallback: string;
  defaultValue: string;
}) {
  const searchParams = useSearchParams();

  return <span>{searchParams.get(paramName) || fallback || defaultValue}</span>;
}
